namespace TabAurous.Stock {
    export namespace StockEnquiryService {
        export const baseUrl = 'Stock/StockEnquiry';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StockEnquiry/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>StockEnquiryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
